import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
function Loading() {
  const { t } = useTranslation();
  return (
    <div
      className="w-100 fs-1 d-flex justify-content-center align-items-center"
      style={{  height: "500px" }}
    >
      <Spin indicator={<LoadingOutlined className="fs-1 me-4" spin />} />
      <span>{t("Loading.Text")}</span>
    </div>
  );
}

export default Loading;
